<div class="max-w-4xl mx-auto px-4 py-6 animate-fade-in border-[#17486f]">
  <div
    class="bg-white rounded-2xl shadow-xl p-6 md:p-8 border border-[#17486f] hover:shadow-2xl transition-shadow duration-300 flex flex-col"
  >
    <div class="flex items-center gap-4 mb-4">
      <div
        class="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-gradient-to-br from-[#1d588a]/10 to-[#1d588a]/5 flex items-center justify-center shadow-sm"
      >
        <mat-icon class="text-[#1d588a] !text-lg md:!text-lg">description</mat-icon>
      </div>
      <div>
        <h1 class="text-xl md:text-3xl font-bold text-[#1d588a] leading-tight">
          {{ serviceConfig.title }}
        </h1>
        <div class="h-1 w-16 bg-gradient-to-r from-[#1d588a] to-[#163f63] rounded-full mt-1"></div>
      </div>
    </div>

    <p class="text-gray-700 text-sm md:text-base mb-3">
      {{ serviceConfig.description }}
    </p>

    <div class="flex flex-wrap gap-3 mb-4">
      <!-- <div
        *ngIf="serviceConfig.processingTime"
        class="flex items-center gap-1 bg-blue-50 text-blue-700 px-3 py-1 rounded-md text-xs font-medium"
      >
        <mat-icon class="text-blue-700 !text-xs mt-4">schedule</mat-icon>
        {{ serviceConfig.processingTime }}
      </div> -->

      <div
        *ngIf="serviceConfig.requiredDocuments?.length"
        class="flex items-center gap-1 bg-gray-50 text-gray-700 px-3 py-1 rounded-md text-xs font-medium"
      ></div>
    </div>

    <ng-container *ngIf="serviceConfig.requiredDocuments?.length">
      <h2 class="text-sm font-semibold text-[#1d588a] mb-2">
        Required Documents ({{ serviceConfig.requiredDocuments?.length }})
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mb-4">
        <ul class="list-none p-0 m-0">
          <li
            *ngFor="let document of serviceConfig.requiredDocuments"
            class="flex items-start gap-2 text-gray-700 text-sm"
          >
            <mat-icon class="text-gray-500 !text-xs mt-0.5">check_circle</mat-icon>
            <span>{{ document }}</span>
          </li>
        </ul>
      </div>
    </ng-container>

    <div *ngIf="serviceConfig.BankDetails?.length" class="mb-4">
      <h2 class="text-sm font-semibold text-[#1d588a] mb-2">Bank Details</h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <div
          *ngFor="let bankDetail of serviceConfig.BankDetails"
          class="p-3 rounded-lg border border-gray-20 bg-gray-20 flex flex-col gap-1"
        >
          <span class="text-[10px] font-semibold uppercase text-gray-500">
            {{ bankDetail.name }}
          </span>
          <span class="text-sm font-semibold text-gray-800">
            {{ bankDetail.value }}
          </span>
        </div>
      </div>
    </div>
    <hr class="my-4" />

    <section class="mb-5">
      <div class="flex items-center justify-between gap-3 mb-3">
        <div>
          <h2 class="text-sm md:text-base font-bold text-[#1d588a]">Fees</h2>
        </div>
        <mat-icon class="text-[#1d588a] !text-lg">payments</mat-icon>
      </div>

      <ng-container *ngIf="serviceConfig.code === ServiceCodeEnum.COMPANY_REGISTRATION">
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div
            class="min-h-[92px] p-4 rounded-lg border border-[#1d588a]/25 bg-[#1d588a]/5 flex flex-col justify-between hover:shadow-md transition"
          >
            <span class="text-[11px] font-semibold uppercase text-[#1d588a]/80">Private</span>
            <div class="flex items-baseline gap-1 text-[#123b5d]">
              <span class="text-sm font-semibold">{{ serviceConfig.currency }}</span>
              <span class="text-2xl font-bold leading-none">{{ serviceConfig.privatePrice }}</span>
            </div>
          </div>
          <div
            class="min-h-[92px] p-4 rounded-lg border border-[#1a4f7a]/25 bg-[#1a4f7a]/5 flex flex-col justify-between hover:shadow-md transition"
          >
            <span class="text-[11px] font-semibold uppercase text-[#1a4f7a]/80">Public</span>
            <div class="flex items-baseline gap-1 text-[#123b5d]">
              <span class="text-sm font-semibold">{{ serviceConfig.currency }}</span>
              <span class="text-2xl font-bold leading-none">{{ serviceConfig.publicPrice }}</span>
            </div>
          </div>
          <div
            class="min-h-[92px] p-4 rounded-lg border border-[#ffd700]/70 bg-[#fff8cc] flex flex-col justify-between hover:shadow-md transition"
          >
            <span class="text-[11px] font-semibold uppercase text-[#8a6a00]">Recognised</span>
            <div class="flex items-baseline gap-1 text-[#5d4700]">
              <span class="text-sm font-semibold">{{ serviceConfig.currency }}</span>
              <span class="text-2xl font-bold leading-none">{{ serviceConfig.recognisedPrice }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="serviceConfig.parent === ServiceCodeEnum.LICENSING">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div
            class="min-h-[104px] p-4 rounded-lg border border-[#1d588a]/25 bg-[#1d588a]/5 flex flex-col justify-between hover:shadow-md transition"
          >
            <span class="text-[11px] font-semibold uppercase text-[#1d588a]/80">Application Fee</span>
            <div class="flex items-baseline gap-1 text-[#123b5d]">
              <span class="text-sm font-semibold">{{ serviceConfig.currency }}</span>
              <span class="text-2xl md:text-3xl font-bold leading-none">{{ serviceConfig.price }}</span>
            </div>
          </div>
          <div
            class="min-h-[104px] p-4 rounded-lg border border-[#ffd700]/70 bg-[#fff8cc] flex flex-col justify-between hover:shadow-md transition"
          >
            <span class="text-[11px] font-semibold uppercase text-[#8a6a00]">Licence Fee</span>
            <div class="flex items-baseline gap-1 text-[#5d4700]">
              <span class="text-sm font-semibold">{{ serviceConfig.currency }}</span>
              <span class="text-2xl md:text-3xl font-bold leading-none">{{ serviceConfig.licenceFee }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          serviceConfig.code !== ServiceCodeEnum.COMPANY_REGISTRATION &&
          serviceConfig.parent !== ServiceCodeEnum.LICENSING
        "
      >
        <div
          class="min-h-[104px] p-4 rounded-lg border border-[#1d588a]/25 bg-[#1d588a]/5 flex flex-col justify-between hover:shadow-md transition"
        >
          <span class="text-[11px] font-semibold uppercase text-[#1d588a]/80">Service Fee</span>
          <div class="flex items-baseline gap-1 text-[#123b5d]">
            <span class="text-sm font-semibold">{{ serviceConfig.currency }}</span>
            <span class="text-2xl md:text-3xl font-bold leading-none">{{ serviceConfig.price }}</span>
          </div>
        </div>
      </ng-container>
    </section>
    <div class="flex justify-end mt-auto pt-2 border-t border-gray-100">
      <button
        (click)="onContinue()"
        class="flex items-center gap-2 px-6 py-2 rounded-lg bg-gradient-to-r from-[#1d588a] to-[#163f63] text-white font-semibold hover:from-[#16446b] hover:to-[#0f2d47] transition duration-200 shadow-md"
      >
        Apply for {{ activeTab }}
        <mat-icon class="text-white !text-sm">arrow_forward</mat-icon>
      </button>
    </div>
  </div>
</div>
